import { styled } from "styled-components";

export const NumberPickerTabWrapper = styled.div`
  width: 100%;
`;

export const NumberPickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
